import React from "react";
import { useTranslation } from "react-i18next";

interface ContributionIntroductionProps {
  currentContributionStep: number;
  employeeMaxMatch: number;
  onCalculatorOpen: () => void;
}

const ContributionIntroduction: React.FC<ContributionIntroductionProps> = ({
  currentContributionStep,
  employeeMaxMatch,
  //onCalculatorOpen,
}) => {
  const { t } = useTranslation();

  return (
    <>
      {currentContributionStep === 1 ? (
        <h4 className="font-semibold mb-[10px]">
          {t("onboarding.contributions.sub_title")}
        </h4>
      ) : (
        <h4 className="font-semibold mb-[10px]">
          {t("onboarding.contributions.allocation_title")}
        </h4>
      )}
      {/*  <p className="mb-[16px]">{t("onboarding.contributions.description")}</p> */}

      {currentContributionStep === 1 ? (
        <p className="mb-[16px]">
          {t("onboarding.contributions.step1_description")}{" "}
          {employeeMaxMatch > 0 && (
            <span>{t("onboarding.contributions.employer_match_text")}</span>
          )}
        </p>
      ) : (
        <p className="mb-[16px]">
          {t("onboarding.contributions.step2_description")}
        </p>
      )}

      {/* <div
        onClick={onCalculatorOpen}
        className="cursor-pointer flex text-[#00ADAC] items-center space-x-1 mb-[48px]"
      >
        <p>{t("onboarding.contributions.calculator_link")}</p>
        <img src={LinkIcon} alt="Calculator" className="w-[18px] h-[18px]" />
        <span className="text-[18px] ml-1">
          <Tooltip
            text={t("onboarding.contributions.form_tooltips.calculator")}
          />
        </span>
      </div> */}
    </>
  );
};

export default ContributionIntroduction;
